import { RichEditor, TextInput } from "components/core";
import { FormikProps } from "formik";
import _ from "lodash";
import numeral from "numeral";
import { FC } from "react";

export interface TreatyEndorsementFormProps {
  form: FormikProps<any>;
}

const TreatyEndorsementForm: FC<TreatyEndorsementFormProps> = ({
  form,
}) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="border mt-2 border-gray-300 border-dashed bg-gray-100 divide-y divide-dashed divide-gray-300 rounded-md">
        <div className="grid grid-cols-4 gap-x-4 gap-y-6  p-4">
          <div className="">
            <span className="block text-sm font-light text-gray-700">
              Treaty Program
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.treaty_program || "N/A"}
            </div>
          </div>
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Ceding company
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.cedant || "N/A"}
            </div>
          </div>
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Reference No.
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.reference || "N/A"}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-x-4 gap-y-6  p-4">
          <div className="">
            <span className="block text-sm font-light text-gray-700">
              Period
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.period || "N/A"}
            </div>
          </div>
          <div className="">
            <span className="block text-sm font-light text-gray-700">
              Currency
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.currency || "N/A"}

            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Withholding Tax (%)
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.wth || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Commission (%)
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.commission || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Brokerage (%)
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {form?.values?.brokerage || "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="grid grid-cols-2 gap-2">
          <>
            <div className="col-span-3">
              <div className="">
                <div className="grid grid-cols-3 gap-6 mt-2">
                  <div className="col-span-3">
                    <RichEditor
                      id={"treaty_endorsement_comment"}
                      label="Treaty Endorsement Comment"
                      placeholder="Enter treaty endorsement comment"
                      required
                      {...form}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default TreatyEndorsementForm;
